import { ID } from "../core/id";
import { UserFrontPrivate, UserFrontPublic } from "../types/users.type";

export interface UserPrivateRequest { }

export interface UserPrivateResponse {
  user: UserFrontPrivate;
}

export interface UserPublicRequest {
  user_id: ID;
}

export interface UserPublicResponse {
  user: UserFrontPublic;
}

export const USER_TRANSFER = '/users/transfer/';
export interface UserTransferRequest {
  shared_user_id: ID;
}

export interface UserTransferResponse {
  is_success: boolean;
}